import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { IDocumento } from './interfaces/documento.interface';
import { DocumentoService } from './services/documento.service';
import { MatDialog } from '@angular/material/dialog';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-documento-form',
  templateUrl: './documento-form.component.html',
  providers: [MessageService]
})
export class DocumentoFormComponent implements OnInit, OnChanges {
  @Input() model: IDocumento | null = null;
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();
  form!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private documentoService: DocumentoService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      if (changes['model'].currentValue) {
        this.loadDocumento();
      } else {
        this.initForm();
      }
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      clavedocumento: [{ value: '', disabled: !!this.model }, [Validators.required]],
      descripcion: ['', [Validators.required]],
      score: [0, [Validators.required, Validators.min(0)]]
    });
  }

  loadDocumento(): void {
    if (!this.model?.clavedocumento) return;
    
    this.loading = true;
    this.documentoService.getDocumentoForEdit(this.model.clavedocumento).subscribe({
      next: (response) => {
        if (response.success && response.data.length > 0) {
          const documento = response.data[0];
          this.form.patchValue({
            clavedocumento: documento.clavedocumento,
            descripcion: documento.descripcion,
            score: documento.score
          });
          this.form.get('clavedocumento')?.disable();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo cargar el documento'
          });
        }
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar el documento'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  create(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    const payload = {
      que: 1,
      tope: '',
      clavedocumento: formData.clavedocumento,
      descripcion: formData.descripcion,
      aplicavigencia: 0,
      score: formData.score
    };

    this.documentoService.saveDocumento(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: 'Documento creado correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.data?.error || 'Error al crear el documento'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al crear el documento'
        });
        this.loading = false;
      }
    });
  }

  update(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    const payload = {
      que: 2,
      tope: '',
      clavedocumento: formData.clavedocumento,
      descripcion: formData.descripcion,
      aplicavigencia: 0,
      score: formData.score
    };

    this.documentoService.saveDocumento(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: 'Documento actualizado correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.data?.error || 'Error al actualizar el documento'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al actualizar el documento'
        });
        this.loading = false;
      }
    });
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'catalogodocumentos',
        sClave: `${this.form.get('clavedocumento')?.value}`,
        sNombre: this.form.get('descripcion')?.value,
        sTipo: 'Opcion'
      }
    });
  }
} 